import React from 'react'
import Button from '../../atoms/Button/Button'
import { ArrowRight } from '../../atoms/NewIcons'
import Link from 'next/link'
import MyImage from '../../atoms/MyImage/MyImage'
import { getAltText } from '../../../utils/safe'

const CatalogoBanner = ({ img, title, description, url, index, cta }) => {
  return (
    <div className={`catalogo__banner`}>
      <div className="catalogo__banner__content">
        <strong>{title}</strong>
        <p>{description}</p>
        {!!url && (
          <div className="catalogo__banner__content__button" style={{ maxWidth: 280 }}>
            <Button next href={url} label={cta} variant="secondary" colorVariant="black" icon={<ArrowRight />} />
          </div>
        )}
      </div>
      {img.url && (
        <div className="catalogo__banner__content__image-wrapper">
          <MyImage
            className="catalogo__banner__content__img catalogo__banner__content__img--desktop"
            src={img.url}
            alt={getAltText(img) || title}
            title={title}
            layout={'fill'}
            objectFit={'cover'}
          />

          <MyImage
            className="catalogo__banner__content__img catalogo__banner__content__img--mobile"
            src={img.url}
            alt={getAltText(img) || title}
            title={title}
            width={460}
            height={275}
          />
        </div>
      )}
    </div>
  )
}

export default CatalogoBanner
